import { Blockquote, VocabularyFooter } from '../../../../src/components/blog';
import { VocabularySeriesBite } from '../../../../src/components/blog/vocabularySeries';
import * as React from 'react';
export default {
  Blockquote,
  VocabularyFooter,
  VocabularySeriesBite,
  React
};